export const DefaultBehaviors = {
  selectable: true,
  removable: true
};
//# sourceMappingURL=behaviors.js.map